import {Component, Input, OnInit} from '@angular/core';
import {ExcTranslation} from 'exc-core-v2';
import {ExgModalService} from 'exc-controls-v2';
import {EnumerationService} from '../../../services/enumeration.service';

@Component({
  selector: 'app-modal-task-state-change',
  templateUrl: './modal-task-state-change.component.html',
  styles: [
  ]
})
export class ModalTaskStateChangeComponent extends ExcTranslation implements OnInit {
  @Input() data: any;

  constructor(
    public modal: ExgModalService,
    public enumSvc: EnumerationService
  ) {
    super();
  }

  ngOnInit(): void {
    this.initialize();
  }

  initialize(): void {

  }

  cancel(): void {
    this.modal.close();
  }

  send(rtValue: any): void {
    this.modal.action(rtValue);
  }
}
